import i18n from "@breward/i18n";
import { colors } from "./colors";

export const DESCRIPTOR_STATES = {
  new: {
    label: i18n.t("global:shared.DescriptorState.New", "New"),
    color: colors.secondary.dark,
  },
  approved: {
    label: i18n.t("global:shared.DescriptorState.Approved", "Approved"),
    color: colors.success.dark,
  },
  rejected: {
    label: i18n.t("global:shared.DescriptorState.Rejected", "Rejected"),
    color: colors.error.dark,
  },
};
